module.exports = __webpack_public_path__ + "img/free-55.523ca4dd.jpg";